import axios from 'axios'
import urls from '@/urls'

let store = {
  namespaced: true,
  state: {
    ownedLicense: false,
    ownedPack: false
  },
  mutations: {
    PAUSE (state) {
      state.pageCurrentPlaying = false
    },
    SET_OWNED_LICENSE (state, payload) {
      state.ownedLicense = payload
    },
    SET_OWNED_PACK (state, payload) {
      state.ownedPack = payload
    }
  },
  getters: {
    getActiveLicenseTier (state) {
      if (!state.ownedLicense || !state.ownedLicense[0]) {
        return []
      }
      switch (state.ownedLicense[0]['product_id']['addition']) {
        case 0:
          return [ 'std', 'pro' ]
        case 2:
          return [ 'std' ]
        case 4:
          return [ 'std', 'pro', 'elite' ]
        default:
          return []
      }
    },
    isOwnedSku: (state) => (sku) => {
      // FIXME This only detects owned software
      if (!state.ownedLicense) { return }
      switch (sku) {
        case 'L2103':
          return state.ownedLicense.find(i => [2, 0, 4].includes(i['product']['addition']))
        case 'L2102':
          return state.ownedLicense.find(i => [0, 4].includes(i['product']['addition']))
        case 'L2101':
          return state.ownedLicense.find(i => i['product']['addition'] === 4)
      }
    },
    isPackActive: (state) => (sku) => {
      // FIXME Implement SKU display in pg-api-backend
      if (!state.ownedPack) { return }
      const table = {
        'L2011': 'Metal Signature Pack',
        'L2012': 'Bass Expansion Pack',
        'L2013': 'Acoustic Expansion Pack',
        'L1111': 'Celestion Modern Vintage Pack',
        'L1114': 'Celestion Classic Pack'
      }
      return state.ownedPack.find(i => {
        if (i['display_name']) {
          return i['display_name'] === table[sku]
        } else {
          return i['product']['display_name'] === table[sku]
        }
      })
    }
  },
  actions: {
    async getOwnedLicense ({ commit, rootState }, { token, product }) {
      const result = await axios({
        method: 'GET',
        headers: {
          'Authorization': `JWT ${rootState.Auth.token || window.localStorage.getItem('PG_TOKEN')}`,
          'Content-Type': 'application/json'
        },
        url: `${urls.NEW_API_URL}/v3/license?pname=${product}`
      })
      const celestions = result.data.license.filter(license => ['celestion-modern-vintage', 'celestion-classic'].includes(license['product']['name']))
      for (var i in celestions) {
        result.data.pack.push(Object.assign({}, celestions[i]))
        result.data.license.splice(result.data.license.indexOf(celestions[i]), 1)
      }
      commit('SET_OWNED_LICENSE', result.data.license)
      commit('SET_OWNED_PACK', result.data.pack)
    }
  }
}

export default store



// WEBPACK FOOTER //
// ./src/store/modules/software.js